
import DesignList from "components/designs-list";

function SavedDesigns() {
  return <DesignList limit={15} heading={"Saved Designs"} showPagination={true} isDeletePage={false}/>;
}

export default SavedDesigns;
